// 404.js
//import Link from 'next/link'

import Head from 'next/head';
import ErrorLayout from '../components/ErrorLayout';

const FourOhFour = ({ err, msg }: { err?: string; msg?: string }) => {
  return (
    <div>
      <Head>
        <title>MongoDB Support: Error</title>
      </Head>
      <div className="not-found-container">
        <img className="not-found-image" src="/images/sadface.gif" />
        <div className="not-found-code">
          {`{`}
          status: 404,
          <br />
          &nbsp;&nbsp;message: "Not Found" {`}`}
        </div>
      </div>

      {!msg && (
        <p className="not-found-text">
          Oops! We can't load the page you were looking for.
        </p>
      )}
    </div>
  );
};
(FourOhFour as any).Layout = ErrorLayout;

export default FourOhFour;
